import moment from 'moment';

export default {
  /*
  短日期
 */
  shortDate: function (value) {
    return moment(value).format("YYYY-MM-DD")
  }
}
